import React from 'react';
import Header from '../../components/header';
import RecommendBody from './body';
import Footer from '../../components/footer';

function Recommend(props) {
    document.title = `Yebokenny | Recommend Business`;
    return (
        <div>
            <Header> </Header>
            <RecommendBody></RecommendBody>
            <Footer></Footer>
        </div>
    );
}

export default Recommend;